module.exports = __webpack_public_path__ + "media/xiaoxin.1b83854c.mp3";